<template>
  <v-overlay :z-index="1000" :value="isLoading" opacity="0.7">
    <div class="text-center pb-4">
      <v-progress-circular
        class="mt-loader"
        color="primary"
        indeterminate
        size="94"
      >
        <v-img
          width="64"
          src="https://thg.blob.core.windows.net/public-images/bt_icon.svg"
        ></v-img>
      </v-progress-circular>
      <div class="mt-2">{{ loadingText }}</div>
    </div>
  </v-overlay>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      isLoading: "shared/isLoading",
      loadingText: "shared/loadingText",
    }),
  },
};
</script>

<style lang="scss" scope>
.mt-loader {
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  position: relative;
}
</style>
